
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"shippingRate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingRate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"estimatedDelivery"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notice"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":117}};
    doc.loc.source = {"body":"fragment shippingRate on ShippingRate {\n  id\n  name\n  price\n  displayPrice\n  selected\n  estimatedDelivery\n  notice\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
